exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".spectrum--dark .spectrum-Underlay {\n  background: rgba(0,0,0,0.5);\n}\n", "", {"version":3,"sources":["/jenkins/workspace/CCX-Comments-Release/node_modules/@react/react-spectrum/spectrum-css/underlay/multiStops/dark.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;CAC7B","file":"dark.css","sourcesContent":[".spectrum--dark .spectrum-Underlay {\n  background: rgba(0,0,0,0.5);\n}\n"],"sourceRoot":""}]);

// exports
